// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host, :host > * {
  height: 100%;
}

.date-selection {
  display: flex;
  align-items: center;
  margin: 1rem 0;
}

.grouped-day {
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--gc-border-color);
}
.grouped-day > .header {
  margin-top: 1rem;
  display: flex;
  align-items: center;
}
.grouped-day:last-child {
  padding-bottom: 0;
  border-bottom: none;
}
.grouped-day .title {
  font-size: 1.25rem;
  flex-grow: 1;
}

.scroll-container {
  position: relative;
}
.scroll-container .scroll-content {
  position: absolute;
  top: 0;
  right: -1.25rem;
  bottom: -1.25rem;
  left: -1.25rem;
  padding: 0 1.25rem;
  overflow: overlay;
}

.absence {
  margin-top: 1rem;
  display: block;
  position: relative;
}
.absence .header {
  padding: 0.5em 0.5em 0 0.5em;
}
.absence .content {
  padding: 0.5rem;
}
.absence .footer {
  border-top: 1px solid var(--gc-border-color);
  padding: 0.5rem;
}
.absence .changes {
  display: flex;
  flex-direction: column;
}
.absence-user {
  font-weight: bold;
}
.absence .confirmed-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: var(--gc-color-success);
  border-radius: 50%;
  margin: 1rem;
  width: 24px;
  height: 24px;
  color: var(--gc-text-color-inverse);
  display: flex;
  align-items: center;
  justify-content: center;
}

.changed-value {
  color: var(--gc-color-danger);
}

a {
  cursor: pointer;
  text-decoration: underline;
}

.evenly-separated-content {
  display: grid;
  grid-template-columns: [dataA] 1fr [dataB] 1fr;
  height: 100%;
  gap: 1rem;
}
.evenly-separated-content .left {
  grid-column: dataA;
}
.evenly-separated-content .right {
  grid-column: dataB;
}`, "",{"version":3,"sources":["webpack://./src/app/v-sidebar/components/absence/absence.sidebar.component.sass"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AAEJ;;AAAA;EACI,oBAAA;EACA,+CAAA;AAGJ;AAFI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AAIR;AAHI;EACI,iBAAA;EACA,mBAAA;AAKR;AAJI;EACI,kBAAA;EACA,YAAA;AAMR;;AAJA;EACI,kBAAA;AAOJ;AANI;EACI,kBAAA;EACA,MAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAQR;;AANA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;AASJ;AARI;EACI,4BAAA;AAUR;AATI;EACI,eAAA;AAWR;AAVI;EACI,4CAAA;EACA,eAAA;AAYR;AAXI;EACI,aAAA;EACA,sBAAA;AAaR;AAZI;EACI,iBAAA;AAcR;AAbI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,mCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAeR;;AAdA;EACI,6BAAA;AAiBJ;;AAfA;EACI,eAAA;EACA,0BAAA;AAkBJ;;AAhBA;EACI,aAAA;EACA,8CAAA;EACA,YAAA;EACA,SAAA;AAmBJ;AAlBI;EACI,kBAAA;AAoBR;AAnBI;EACI,kBAAA;AAqBR","sourcesContent":[":host, :host > *\n    height: 100%\n\n.date-selection\n    display: flex\n    align-items: center\n    margin: 1rem 0\n\n.grouped-day\n    padding-bottom: 2rem\n    border-bottom: 1px solid var(--gc-border-color)\n    > .header\n        margin-top: 1rem\n        display: flex\n        align-items: center\n    &:last-child\n        padding-bottom: 0\n        border-bottom: none\n    .title\n        font-size: 1.25rem\n        flex-grow: 1\n\n.scroll-container\n    position: relative\n    .scroll-content\n        position: absolute\n        top: 0\n        right: -1.25rem\n        bottom: -1.25rem\n        left: -1.25rem\n        padding: 0 1.25rem\n        overflow: overlay\n\n.absence\n    margin-top: 1rem\n    display: block\n    position: relative\n    .header\n        padding: 0.5em 0.5em 0 0.5em\n    .content\n        padding: 0.5rem\n    .footer\n        border-top: 1px solid var(--gc-border-color)\n        padding: 0.5rem\n    .changes\n        display: flex\n        flex-direction: column\n    &-user\n        font-weight: bold\n    .confirmed-badge\n        position: absolute\n        top: 0\n        right: 0\n        background: var(--gc-color-success)\n        border-radius: 50%\n        margin: 1rem\n        width: 24px\n        height: 24px\n        color: var(--gc-text-color-inverse)\n        display: flex\n        align-items: center\n        justify-content: center\n.changed-value\n    color: var(--gc-color-danger)\n\na\n    cursor: pointer\n    text-decoration: underline\n\n.evenly-separated-content\n    display: grid\n    grid-template-columns: [dataA] 1fr [dataB] 1fr\n    height: 100%\n    gap: 1rem\n    .left\n        grid-column: dataA\n    .right\n        grid-column: dataB"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
